import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminBalanceCard = _resolveComponent("AdminBalanceCard")!
  const _component_AdminUsersFilter = _resolveComponent("AdminUsersFilter")!
  const _component_AdminUsersTable = _resolveComponent("AdminUsersTable")!
  const _component_AdminUsersStatus = _resolveComponent("AdminUsersStatus")!
  const _component_AdminUsersBalance = _resolveComponent("AdminUsersBalance")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("h1", {
      class: _normalizeClass(_ctx.b('title'))
    }, _toDisplayString(_ctx.$t("Пользователи")), 3),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('balances'))
    }, [
      _createVNode(_component_AdminBalanceCard, {
        class: _normalizeClass(_ctx.b('balance-card')),
        "user-id": _ctx.inUserId,
        label: "IN"
      }, null, 8, ["class", "user-id"]),
      _createVNode(_component_AdminBalanceCard, {
        class: _normalizeClass(_ctx.b('balance-card')),
        "user-id": _ctx.outUserId,
        label: "OUT"
      }, null, 8, ["class", "user-id"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('wrapper'))
    }, [
      _createVNode(_component_AdminUsersFilter, {
        value: _ctx.search.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.value) = $event)),
        type: _ctx.search.type,
        "onUpdate:type": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.type) = $event)),
        status: _ctx.search.status,
        "onUpdate:status": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.status) = $event))
      }, null, 8, ["value", "type", "status"]),
      _createVNode(_component_AdminUsersTable, {
        class: _normalizeClass(_ctx.b('table')),
        search: _ctx.search,
        sort: _ctx.sort,
        "is-status": _ctx.isStatus,
        "onUpdate:isStatus": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isStatus) = $event)),
        "is-balance": _ctx.isBalance,
        "onUpdate:isBalance": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isBalance) = $event))
      }, null, 8, ["class", "search", "sort", "is-status", "is-balance"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('pagination'))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('pagination-item', { active: _ctx.sort.page == 1 })),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage(1)))
        }, "1", 2),
        (_ctx.sort.page > 4)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(_ctx.b('pagination-item', { dots: true }))
            }, "...", 2))
          : _createCommentVNode("", true),
        (_ctx.sort.page - 2 > 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(_ctx.b('pagination-item')),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPage(_ctx.sort.page - 2)))
            }, _toDisplayString(_ctx.sort.page - 2), 3))
          : _createCommentVNode("", true),
        (_ctx.sort.page - 1 > 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass(_ctx.b('pagination-item')),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage(_ctx.sort.page - 1)))
            }, _toDisplayString(_ctx.sort.page - 1), 3))
          : _createCommentVNode("", true),
        (_ctx.sort.page != 1 && _ctx.sort.page != _ctx.lastPage)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: _normalizeClass(_ctx.b('pagination-item', { active: true })),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage(_ctx.sort.page)))
            }, _toDisplayString(_ctx.sort.page), 3))
          : _createCommentVNode("", true),
        (_ctx.sort.page + 1 < _ctx.lastPage)
          ? (_openBlock(), _createElementBlock("span", {
              key: 4,
              class: _normalizeClass(_ctx.b('pagination-item')),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage(_ctx.sort.page + 1)))
            }, _toDisplayString(_ctx.sort.page + 1), 3))
          : _createCommentVNode("", true),
        (_ctx.sort.page + 2 < _ctx.lastPage)
          ? (_openBlock(), _createElementBlock("span", {
              key: 5,
              class: _normalizeClass(_ctx.b('pagination-item')),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.sort.page + 2)))
            }, _toDisplayString(_ctx.sort.page + 2), 3))
          : _createCommentVNode("", true),
        (_ctx.sort.page < _ctx.lastPage - 3)
          ? (_openBlock(), _createElementBlock("span", {
              key: 6,
              class: _normalizeClass(_ctx.b('pagination-item', { dots: true }))
            }, "...", 2))
          : _createCommentVNode("", true),
        (_ctx.lastPage != 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 7,
              class: _normalizeClass(_ctx.b('pagination-item', { active: _ctx.sort.page == _ctx.lastPage })),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPage(_ctx.lastPage)))
            }, _toDisplayString(_ctx.lastPage), 3))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isStatusShow)
          ? (_openBlock(), _createBlock(_component_AdminUsersStatus, {
              key: 0,
              class: _normalizeClass(_ctx.b('modal')),
              isStatus: _ctx.isStatus,
              "onUpdate:isStatus": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isStatus) = $event))
            }, null, 8, ["class", "isStatus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "opacity" }, {
      default: _withCtx(() => [
        (_ctx.isBalanceShow)
          ? (_openBlock(), _createBlock(_component_AdminUsersBalance, {
              key: 0,
              class: _normalizeClass(_ctx.b('modal')),
              isBalance: _ctx.isBalance,
              "onUpdate:isBalance": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isBalance) = $event))
            }, null, 8, ["class", "isBalance"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}